import { Link } from 'react-router-dom';

export default function ProductsHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-forest-green/30 via-deep-black to-deep-black"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
          <Link to="/" className="hover:text-copper transition-colors duration-200 cursor-pointer">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-copper">Products</span>
        </nav>

        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="font-serif text-5xl lg:text-7xl text-white mb-6">
            Premium <span className="text-copper">Products</span>
          </h1>
          <div className="w-16 h-0.5 bg-copper mx-auto mb-8"></div>
          <p className="text-gray-300 text-xl leading-relaxed">
            Explore our carefully curated collection of vapes, glass pieces, hand blown glass, hookah setups, Hemp products, and premium accessories.
          </p>
        </div>
      </div>
    </section>
  );
}
